import { ErrorService } from 'src/services';
import { createReducer } from 'typesafe-actions';
import { addUserAsync, getUsersAsync, setUsers, setOpenUserModal, updateUserAsync, setRefreshTable } from './actions';
import { UserInfo, UserModalType } from './types';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */

export type IUsersState = Readonly<{
  users: Array<UserInfo>;
  totalUsers: number;
  isLoading: boolean;
  isRefreshTable: boolean;
  openUserModal: UserModalType;
  error?: Error;
}>;

const initialState: IUsersState = {
  users: [],
  totalUsers: 0,
  isLoading: false,
  isRefreshTable: false,
  openUserModal: null,
};

/* ------------- Selectors ------------- */

export default createReducer(initialState)
  /* ------------- usersAsync ------------- */
  .handleAction(getUsersAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(getUsersAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    users: action.payload.users as UserInfo[],
    totalUsers: action.payload.total,
    error: null,
  }))
  .handleAction(getUsersAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- usersUpdateAsync ------------- */
  .handleAction(updateUserAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(updateUserAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    openUserModal: false,
    isRefreshTable: true,
    error: null,
  }))
  .handleAction(updateUserAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- usersAddAsync ------------- */

  .handleAction(addUserAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(addUserAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    openUserModal: false,
    isRefreshTable: true,
    error: null,
  }))
  .handleAction(addUserAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- setUsers ------------- */
  .handleAction(setUsers, (state, action) => ({
    ...state,
    users: action.payload,
  }))
  .handleAction(setRefreshTable, (state, action) => ({
    ...state,
    isRefreshTable: action.payload,
  }))
  .handleAction(setOpenUserModal, (state, action) => ({
    ...state,
    openUserModal: action.payload,
  }));
